<div class="dashboard-container">
    <header class="dashboard-header">
        <h1 class="page-title">{{ 'pages.collections.dashboard.page_title' | secondaryNavTitle }}</h1>
        <nav mat-tab-nav-bar [tabPanel]="tabPanel" class="dashboard-tabs">
            <a mat-tab-link
               [routerLink]="['manage']"
               routerLinkActive
               #manageLink="routerLinkActive"
               [active]="manageLink.isActive">
                {{ 'pages.collections.dashboard.tab_manage' | translate }}
            </a>
            <a mat-tab-link
               [routerLink]="['analytics']"
               routerLinkActive
               #analyticsLink="routerLinkActive"
               [active]="analyticsLink.isActive">
                {{ 'pages.collections.dashboard.tab_analytics' | translate }}
            </a>
            <a mat-tab-link
               [routerLink]="['config']"
               routerLinkActive
               #configLink="routerLinkActive"
               [active]="configLink.isActive">
                {{ 'pages.collections.dashboard.tab_configuration' | translate }}
            </a>
        </nav>
    </header>

    <mat-tab-nav-panel #tabPanel>
        <router-outlet></router-outlet>
    </mat-tab-nav-panel>
</div>
